import React,{useState} from 'react';
import {Form,Col,Container,Table,Alert} from 'react-bootstrap';
import Title from '../../utilities/other/title';
import QTable from '../../utilities/tableQuestionnaire/questionnaire'
function AnswerField(props){
   
    const answers = props.answers
    const [value,setVal]  = useState(props.data!=null?props.data:"")
    
    const handler = (event) =>{
        setVal(event.target.value)
        props.handler(event)
    }
    return(
   
    <Form.Group as={Col}>
            
            <Form.Control as={"select"} onChange={handler} name={props.name} value={value} disabled={props.disabled} >
                    {answers.map((answer,index)=><option key={index}>{answer}</option>)}
            </Form.Control>
         </Form.Group>
  
    )
}
AnswerField.defaultProps ={
    data:null
}
function AnswerField_double(props){
    const [disabled , setDisabled] = useState(props.data!=null&&(props.data[0]=='Yes'?false:true))
    const [value,setValue] = useState(props.data!=null?props.data[1]:"")
    const [value1,setValue1] = useState(props.data!=null?props.data[0]:"")
    const valueChange=(event) =>{
        if (disabled == true){
            setValue("")
        }
        else{
            setValue(event.target.value)
        }
        props.handler(event)
    }
   
    const onChange=(event) =>{
        setValue1(event.target.value)
        if(event.target.value ==='No' || event.target.value ===""){
            setDisabled(true)
            setValue("")
        }
        else{
            setDisabled(false)
        }
        
        props.handler(event)
        

    }
    
    const title = props.title.replace(" ","_")
    return(
        <Form>
            <Form.Row>
            <Form.Group as={Col}>
                <Form.Label>{props.title}</Form.Label>
                <Form.Control as={'select'} onChange={onChange} name={title} value={value1} disabled={props.disabled}>
                    <option></option>
                    <option>Yes</option>
                    <option>No</option>
                </Form.Control>
            </Form.Group>
            <Form.Group as={Col}>
                <Form.Label>Medication:</Form.Label>
                <Form.Control type="text" disabled={disabled} name={title+'_medication'} onChange={valueChange} disabled={props.disabled!=null?props.disabled:disabled} value={value}/>
            </Form.Group>
            </Form.Row>
        </Form>

    )
}
AnswerField_double.defaultProps ={
    data:null
}

class  Scopa_aut extends React.Component {
    constructor(props) {
        super(props)
        this.state ={}
    }
    questions =[
        "In the past month, have you had difficulty swallowing or have you choked?",
        "In the past month, has saliva dribbled out of your mouth?",
        "In the past month, has food ever become stuck in your throat?",
        "In the past month, did you ever have the feeling during a meal that you were full very  quickly?",
        "Constipation is a blockage of the bowel, a condition in which someone has a bowel movement twice a week or less. In the past month, have you had problems with constipation?",
        "In the past month, did you have to strain hard to pass stools?",
        "In the past month, have you had involuntary loss of stools?",
        "In the past month, have you had difficulty retaining urine?",
        "In the past month, have you had involuntary loss of urine?",
        "In the past month, have you had the feeling that after passing urine your bladder was  not completely empty?",
        "In the past month, has the stream of urine been weak?",
        "In the past month, have you had to pass urine again within 2 hours of the previous time?",
        "In the past month, have you had to pass urine at night?",
        "In the past month, when standing up have you had the feeling of either becoming lightheaded, or no longer being able to see properly, or no longer being able to think clearly?",
        "In the past month, did you become light-headed after standing for some time?",
        "Have you fainted in the past 6 months?",
        "In the past month, have you ever perspired excessively during the day?",
        "In the past month, have you ever perspired excessively during the night?",
        "In the past month, have your eyes ever been over-sensitive to bright light?",
        "In the past month, how often have you had trouble tolerating cold?",
        "In the past month, how often have you had trouble tolerating heat?",
        "In the past month, have you used medication for:"
        


   ]
    men_questions =["In the past month, have you been impotent (unable to have or maintain an erection)?",
   "In the past month, how often have you been unable to ejaculate?",
   "In the past month, have you taken medication for an erection disorder? (If so, which  medication?)"]
    female_questions =["In the past month, was your vagina too dry during sexual activity?",
        "In the past month, have you had difficulty reaching an orgasm?"

    ]

    answers =['','never','sometimes','regularly','often']
    answers2 = this.answers.concat('not applicable')
    medication_for = ['constipation','urinary problems','blood pressure','other symptoms']

    answerScore = {'': null, 'never': 0, 'sometimes': 1, 'regularly': 2, 'often': 3, 'not applicable': 0}

    scoreOf = (key) => this.answerScore[this.state[key]] ?? null

    computeScores = () => {
        const s = this.scoreOf
        const sum = (...keys) => {
            let total = 0
            for (const k of keys) {
                const v = s(k)
                if (v === null) return null
                total += v
            }
            return total
        }
        const gastrointestinal = sum(1, 2, 3, 4, 5, 6, 7)
        const urinary          = sum(8, 9, 10, 11, 12, 13)
        const cardiovascular   = sum(14, 15, 16)
        const thermoregulatory = sum(17, 18, 20, 21)
        const pupillomotor     = sum(19)
        const sexual = this.props.gender === 'Male'   ? sum(22, 23)
                     : this.props.gender === 'Female' ? sum(24, 25)
                     : null
        const parts = [gastrointestinal, urinary, cardiovascular, thermoregulatory, pupillomotor, sexual]
        const mandatory = [gastrointestinal, urinary, cardiovascular, thermoregulatory, pupillomotor]
        const total = mandatory.every(p => p !== null)
            ? mandatory.reduce((a, b) => a + b, 0) + (sexual ?? 0)
            : null
        return {
            gastrointestinal_score: gastrointestinal,
            urinary_score:          urinary,
            cardiovascular_score:   cardiovascular,
            thermoregulatory_score: thermoregulatory,
            pupillomotor_score:     pupillomotor,
            sexual_score:           sexual,
            total_score:            total,
        }
    }

    onChange = async (event) => {
        const {name, value} = event.target
        await this.setState((prevState) => ({ ...prevState, [name]: value }))
        const scores = this.computeScores()
        await this.setState((prevState) => ({ ...prevState, ...scores }))
        this.props.handler('scopa_aut', this.state)
    }
    componentDidUpdate(prevProps,prevState){
        // if(prevState != this.state){
        //     this.props.handler('scopa_aut',this.state)
        // }
    }
    componentDidMount(){
        if(this.props.data!= null){
            this.setState(this.props.data)
        }
    }
    render(){
        return(
            <div>
                
                <Container>
                
                    <Title>SCOPA-AUT</Title>
                    {(this.props.gender == null || this.props.gender=="" )&& <Alert variant="primary" style={{marginTop:20}}>Please select gender in demographics tab</Alert>}
                    <br/>
                    <Table responsive={true} bordered={false} size="md" hover={true} striped={false}>
                        <thead style={{position:'sticky'}}>
                        
                            <tr>
                                
                                <th>Question</th>
                                <th width={200}>Answer</th>
                            
                            </tr>
                        </thead>
                        <tbody>
                            
                            {this.questions.map((items,index ) =>
                                <>
                                {index ==7&&(<>

                            
                                <tr><td><h5>Questions 8 to 13 deal with problems with passing urine. If you use a catheter you can
                                            indicate this by placing a cross in the box “use cathether”.</h5></td></tr>
                                </>)}
                                {index<=20 &&<tr key={index}>
                                    
                                    <th><p>{index+1}.{items}</p></th>
                                    <th>{this.props.data!= null?<AnswerField name={index+1} data={this.props.data[index+1]} handler={this.onChange} disabled={this.props.disabled} answers={this.answers}/>:<AnswerField name={index+1} handler={this.onChange} answers={this.answers}/>}</th>
                                    
                                </tr>}
                                
                                
                                </>
                            )}
                        </tbody>
                        </Table>
                        {(this.props.gender !=null&& this.props.gender!="") && <Alert variant="info">
                            Note: Questions not related to the selected gender are skipped
                        </Alert>}
                    <Table responsive={true} bordered={false} size="md" hover={true} striped={false}>
                        <tbody>
                        
                    
                            {this.props.gender=="Male"&& this.men_questions.map((item, index)=>(
                                <>
                            {index==0 && <tr><td><h5>Men</h5></td></tr>}
                                <tr key={index}>
                                <th><p>{index === 2 ? '23a' : index+1+21}.{item}</p></th>
                                    <th>{this.props.data!=null ?<AnswerField name={index === 2 ? '23a' : index+1+21} data={this.props.data[index === 2 ? '23a' : index+1+21]} disabled={this.props.disabled}  handler={this.onChange} answers={this.answers2}/>:<AnswerField name={index === 2 ? '23a' : index+1+21} handler={this.onChange} answers={this.answers2}/>}</th>
                                </tr>
                                </>
                            ))}
                        
                    
                            {this.props.gender=="Female"&& this.female_questions.map((item, index)=>(
                                <>
                            {index==0 && <tr><td><h5>Female</h5></td></tr>}
                                <tr key={index}>
                                <th><p>{index+1+23}.{item}</p></th>
                                <th width={200}>{this.props.data!=null ?<AnswerField name={index+1+23} disabled={this.props.disabled} handler={this.onChange} data={this.props.data[index+1+23]} answers={this.answers2}/>:<AnswerField name={index+1+23} handler={this.onChange} answers={this.answers2}/>}</th>
                                </tr>
                                </>
                            ))}
                            
                            
                        </tbody>
                    
                    
                    
                    </Table>
                    {this.questions.slice(-1).map((item,key)=>(
                        <p style={{fontSize:18,fontWeight: 'bold'}} key={key}>26.{item}</p>
                    ))}
                    {this.medication_for.map((item,key)=>(
                        
                       <> {this.props.data!=null?<AnswerField_double title={item} data={[this.props.data[item.replace(" ","_")], this.props.data[item.replace(" ","_")+'_medication']]}  disabled={this.props.disabled} handler={this.onChange} key={key} t={item.replace(" ","_")}/>:
                       
                       <AnswerField_double title={item}  handler={this.onChange} key={key} />
                       
                       }</>
                    ))}
                    

                    {(() => {
                        const sc = this.computeScores()
                        const fmt = (v, max) => v !== null ? `${v} / ${max}` : '—'
                        const rows = [
                            ['Gastrointestinal', sc.gastrointestinal_score, 21],
                            ['Urinary',          sc.urinary_score,          18],
                            ['Cardiovascular',   sc.cardiovascular_score,    9],
                            ['Thermoregulatory', sc.thermoregulatory_score, 12],
                            ['Pupillomotor',     sc.pupillomotor_score,      3],
                            ['Sexual function',  sc.sexual_score,            6],
                        ]
                        return (
                            <Table bordered size="sm" style={{marginTop: 24}}>
                                <thead>
                                    <tr><th colSpan={2} style={{textAlign:'center'}}>SCOPA-AUT Scores</th></tr>
                                </thead>
                                <tbody>
                                    {rows.map(([label, val, max]) => (
                                        <tr key={label}>
                                            <td>{label}</td>
                                            <td><strong>{fmt(val, max)}</strong></td>
                                        </tr>
                                    ))}
                                    <tr style={{borderTop: '2px solid #dee2e6'}}>
                                        <td><strong>Total</strong></td>
                                        <td><strong>{fmt(sc.total_score, 69)}</strong></td>
                                    </tr>
                                </tbody>
                            </Table>
                        )
                    })()}
                </Container>
                </div>
            // <QTable title="SCOPA AUT" questions={questions} answers={['','yes','no']} handler={this.props.handler} fieldName={'scopa_aut'}/>
        )
    }
}
Scopa_aut.defaultProps = {
    gender:null,
    data:null,
    disabled:false
}
export default Scopa_aut;